"use strict";
// Toggle.ts
//
// Toggle enum that list all the available toggles for the project. Note that each toggle could be
// enabled in one deployment environment but disabled in another. When configuring the toggles in
// the .env file or the deployment/.ebextensions/03.env.config you can specify the list of
// deployments for which a certain toggle is enabled (e.g. TOGGLE_DEV_TABLE=LOCAL|DEV => enabled in
// local and dev deployments).
// When the list of values for a toggle contains "OFF", then the toggle is off in all deployments
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toggle = void 0;
exports.convertStringToToggle = convertStringToToggle;
var Toggle;
(function (Toggle) {
    /* enabling playing on a dev table */
    Toggle[Toggle["DEV_TABLE"] = "dev_table"] = "DEV_TABLE";
    /* enabling playing on a test table (ie. with passed seed) */
    Toggle[Toggle["TEST_TABLE"] = "test_table"] = "TEST_TABLE";
    /* key name for enabling mailchimp service */
    Toggle[Toggle["MAILCHIMP"] = "mailchimp"] = "MAILCHIMP";
    /* key name for enabling AWS SES email service (replaces Mailchimp when enabled) */
    Toggle[Toggle["AWS_SES_EMAIL"] = "aws_ses_email"] = "AWS_SES_EMAIL";
})(Toggle || (exports.Toggle = Toggle = {}));
function convertStringToToggle(name) {
    for (const key of Object.keys(Toggle)) {
        if (Toggle[key] === name) {
            return Toggle[key];
        }
    }
    return undefined;
}
//# sourceMappingURL=Toggle.js.map